// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-3J48R3w4cL3p_pAV3Y_GlO","pos":"pos-2lsZx1kh6DL6abLeAAVvXk","neg":"neg-3X0ExomXHKmhJmxYY8YsGI","neu":"neu-28GZwDC-oAEm9lxzHEdt36"};